











































































































import { Component, Emit, Prop, Watch } from 'nuxt-property-decorator'
import { each, find, assign, map, sumBy } from 'lodash'
import ResizeObserver from 'resize-observer-polyfill'
import { jsonFormat } from '@/utils'
import { ComponentVue } from '@/base'
import DataTableHeader from './DataTableHeader.vue'
import DataTableRow from './DataTableRow.vue'
import {
  Col,
  Move,
  Resize,
  BODY_HEIGHT,
  SCROLL_WIDTH,
  MIN_WIDTH,
  ColInfo,
  SortColumn,
  ColItem
} from '.'

const resizeDefaultValue: Resize = {
  doing: false,
  cursor: {
    downX: 0,
    currentX: 0,
    upX: 0,
    differenceX: 0
  },
  column: {
    left: {
      index: 0,
      originalIndex: 0,
      width: 0,
      newWidth: 0
    },
    right: {
      index: 0,
      originalIndex: 0,
      width: 0,
      newWidth: 0
    }
  }
}

const moveDefaultValue: Move = {
  doing: false,
  ruler: -1,
  cursor: {
    downX: 0,
    currentX: 0,
    upX: 0,
    differenceX: 0,
    direction: ''
  },
  column: {
    initial: {
      startX: 0,
      endX: 0
    },
    current: {
      startX: 0,
      endX: 0
    },
    index: 0,
    originalIndex: 0
  }
}

@Component({
  components: { DataTableHeader, DataTableRow }
})
export default class DataTable extends ComponentVue {
  @Prop({
    type: Boolean,
    default: false
  })
  showDebug!: boolean

  @Prop({
    type: Array
  })
  cols!: Col[]

  @Prop({
    type: Array,
    default: () => []
  })
  items!: object[] | string[]

  @Prop({
    type: Boolean,
    default: false
  })
  isAllSelect!: boolean

  @Prop({
    type: Number,
    default: BODY_HEIGHT
  })
  height!: number

  @Prop({
    type: Boolean,
    default: false
  })
  disabledAllSelect!: boolean

  @Prop({
    type: Number,
    default: -1
  })
  activeRowIndex!: number

  colsInfo: ColInfo[] = []

  colsOrderList: number[] = []

  resize: Resize = assign({}, resizeDefaultValue)

  move: Move = assign({}, moveDefaultValue)

  tableWidth = 0

  observer: ResizeObserver | null = null

  get tableBodyHeight(): number {
    return this.height
  }

  get itemsCount(): number {
    return this.items.length
  }

  get colNames(): string[] {
    const names: string[] = []
    each(this.showCols, (col: Col) => {
      each(col.items, (colItem: ColItem) => {
        names.push(colItem.name)
      })
    })
    return names
  }

  get parseResize() {
    return jsonFormat(this.resize)
  }

  get parseMove() {
    return jsonFormat(this.move)
  }

  get tableClass() {
    return {
      resizing: this.resize.doing,
      width: this.totalWidthWithScroll + 'px'
    }
  }

  get totalWidth(): number {
    // this.debug('totalWidth', this.colsInfo)
    return sumBy<ColInfo>(this.colsInfo, 'calcWidth')
  }

  get totalWidthWithScroll(): number {
    return this.totalWidth + SCROLL_WIDTH
  }

  get tableBodyStyle() {
    return {
      width: this.totalWidthWithScroll + 'px',
      height: this.tableBodyHeight + 'px'
    }
  }

  get fixedColumnIndex() {
    let index = -1
    for (let i = 0; i < this.colsInfo.length; i++) {
      if (!this.colsInfo[i].movable) {
        index = i
      }
    }

    return index
  }

  get showCols(): Col[] {
    return this.cols
  }

  get tableRowClass(): any {
    return (index: number) => {
      return {
        odd: index % 2 === 1,
        even: index % 2 !== 1,
        active: index === this.activeRowIndex
      }
    }
  }

  @Watch('tableWidth')
  changeTableWidth(): void {
    // this.debug('changeTableWidth()')
    this.setColumn()
  }

  @Watch('showCols')
  changeCols(): void {
    this.setColumn()
  }

  @Watch('height')
  changeHeight(): void {
    // this.debug('height', this.height)
  }

  mounted() {
    // this.debug('mounted()')
    window.addEventListener('mouseup', this.onMouseUp)

    this.observer = new ResizeObserver(entries => {
      const width = (entries[0].target as HTMLElement).offsetWidth
      this.onResize(width)
    })
    this.observer.observe(this.$refs.rootDataTable as Element)
  }

  beforeDestroy() {
    // this.debug('beforeDestroy()')
    window.removeEventListener('mouseup', this.onMouseUp)
    this.observer && this.observer.disconnect()
  }

  setColumn(): void {
    let index = 0
    this.colsInfo = map(
      this.showCols,
      (col: Col): ColInfo => {
        return Object.assign({}, col, {
          index: index++,
          startX: 0,
          moving: false,
          calcWidth: 0
        })
      }
    )

    this.colsOrderList = []
    each(this.colsInfo, (colsInfo: ColInfo) => {
      this.colsOrderList.push(colsInfo.index)
    })

    this.colsPositionReset()

    this.calcColumnWidth()
  }

  calcColumnWidth() {
    // this.debug('calcColumnWidth()', this.tableWidth)
    if (this.tableWidth === 0) return
    if (this.colsInfo.length === 0) return

    // 3だとちょうどいい・・・
    const width = this.tableWidth - SCROLL_WIDTH - 3
    // this.debug('colsInfo', this.colsInfo)
    // this.debug('width', width)

    let fixWidth = 0
    each(this.colsInfo, (colInfo: ColInfo) => {
      if (typeof colInfo.width === 'number') {
        fixWidth += colInfo.width
      }
    })

    const baseWidth = width - fixWidth
    let totalWidth = 0
    each(this.colsInfo, (colInfo: ColInfo) => {
      if (typeof colInfo.width === 'number') {
        // this.debug('colInfo.width', colInfo.width)
        colInfo.calcWidth = colInfo.width
      } else {
        const w = Math.round(baseWidth * (Number(colInfo.width) / 100))
        colInfo.calcWidth = w
      }
      totalWidth += colInfo.calcWidth
    })

    // 差異を求め
    const diffWidth = width - totalWidth
    this.colsInfo[this.colsInfo.length - 1].calcWidth += diffWidth
  }

  onMouseUp(event: MouseEvent) {
    // this.debug('onMouseUp()', event)
    if (this.resize.doing) {
      this.resizeEnd(event)
    }

    if (this.move.doing) {
      this.moveEnd(event)
    }
  }

  onMouseMove(event: MouseEvent) {
    // this.debug('onMouseMove()', event)
    if (this.resize.doing) {
      this.resizing(event)
    }

    if (this.move.doing) {
      this.moving(event)
    }
  }

  onResize(width: number) {
    this.tableWidth = width
  }

  onSort(sortColumn: SortColumn) {
    // this.debug('onSort()')
    this.$emit('sort', sortColumn)
  }

  resizeStart(event: MouseEvent, colIndex: number) {
    if (this.resize.doing) {
      this.resizeEnd(event)
    }

    const leftColIndex = colIndex
    const rightColIndex = colIndex + 1

    const originalLeftColIndex = this.originalColumnIndex(colIndex)
    const originalRightColIndex = this.originalColumnIndex(colIndex + 1)

    const leftColumn = find<ColInfo>(this.colsInfo, {
      index: originalLeftColIndex
    })
    const rightColumn = find<ColInfo>(this.colsInfo, {
      index: originalRightColIndex
    })

    assign<Resize, Resize>(this.resize, {
      doing: true,
      cursor: {
        downX: event.pageX,
        currentX: 0,
        upX: 0,
        differenceX: 0
      },
      column: {
        left: {
          index: leftColIndex,
          originalIndex: originalLeftColIndex,
          width: leftColumn ? leftColumn.calcWidth : -1,
          newWidth: leftColumn ? leftColumn.calcWidth : -1
        },
        right: {
          index: rightColIndex,
          originalIndex: originalRightColIndex,
          width: rightColumn ? rightColumn.calcWidth : -1,
          newWidth: rightColumn ? rightColumn.calcWidth : -1
        }
      }
    })
  }

  resizing(event: MouseEvent) {
    if (!this.resize.doing) {
      return
    }

    this.resize.cursor.differenceX = event.pageX - this.resize.cursor.downX

    const newLeftWidth =
      this.resize.column.left.width + this.resize.cursor.differenceX
    const newRightWidth =
      this.resize.column.right.width - this.resize.cursor.differenceX

    if (newLeftWidth < MIN_WIDTH || newRightWidth < MIN_WIDTH) {
      return
    }

    this.resize.column.left.newWidth = newLeftWidth
    this.resize.column.right.newWidth = newRightWidth

    const leftOriginalIndex = this.resize.column.left.originalIndex
    const rightOriginalIndex = this.resize.column.right.originalIndex
    this.colsInfo[leftOriginalIndex].calcWidth = newLeftWidth
    this.colsInfo[rightOriginalIndex].calcWidth = newRightWidth
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  resizeEnd(event: MouseEvent) {
    this.resize.doing = false
    this.colsPositionReset()
  }

  moveStart(event: MouseEvent, colIndex: number) {
    // this.debug('moveStart()')

    assign<Move, Move>(this.move, moveDefaultValue)

    const originalColumnIndex = this.originalColumnIndex(colIndex)

    if (!this.colsInfo[originalColumnIndex].movable) {
      return
    }
    this.colsInfo[originalColumnIndex].moving = true

    assign<Move, Move>(this.move, {
      doing: true,
      ruler: colIndex,
      cursor: {
        downX: event.pageX,
        currentX: 0,
        upX: 0,
        differenceX: 0,
        direction: ''
      },
      column: {
        initial: {
          startX: this.colsInfo[originalColumnIndex].startX,
          endX:
            this.colsInfo[originalColumnIndex].startX +
            this.colsInfo[originalColumnIndex].calcWidth
        },
        current: {
          startX: this.colsInfo[originalColumnIndex].startX,
          endX:
            this.colsInfo[originalColumnIndex].startX +
            this.colsInfo[originalColumnIndex].calcWidth
        },
        index: colIndex,
        originalIndex: originalColumnIndex
      }
    })
  }

  moving(event: MouseEvent) {
    if (!this.move.doing) {
      return
    }
    // this.debug('moving()')

    this.move.cursor.currentX = event.pageX
    this.move.cursor.differenceX = event.pageX - this.move.cursor.downX

    this.move.column.current.startX =
      this.move.column.initial.startX + this.move.cursor.differenceX
    this.move.column.current.endX =
      this.move.column.initial.endX + this.move.cursor.differenceX

    this.moveDifferenceX()

    if (Math.abs(this.move.cursor.differenceX) >= 50) {
      this.setMoveRuler()
    }
  }

  moveDifferenceX() {
    this.move.cursor.differenceX =
      this.move.cursor.currentX - this.move.cursor.downX

    this.toggleMoveColumnDirection()
  }

  toggleMoveColumnDirection() {
    if (this.move.cursor.differenceX === 0) {
      this.move.cursor.direction = ''
      return
    }

    if (this.move.cursor.differenceX < 0) {
      if (this.move.cursor.direction === 'right') {
      }
      this.move.cursor.direction = 'left'
    }

    if (this.move.cursor.differenceX > 0) {
      if (this.move.cursor.direction === 'left') {
      }
      this.move.cursor.direction = 'right'
    }
  }

  setMoveRuler() {
    const direction = this.move.cursor.direction
    if (direction === '') {
      return
    }

    const oldRuler = this.move.ruler

    if (direction === 'left') {
      if (this.move.ruler === 0) {
        return
      }

      if (this.move.ruler === -1) {
        this.move.ruler = this.move.column.index - 1
      } else {
        this.move.ruler--
      }
    }

    if (direction === 'right') {
      if (this.move.ruler === this.colsInfo.length) {
        return
      }

      if (this.move.ruler === -1) {
        this.move.ruler = this.move.column.index + 1
      } else {
        this.move.ruler++
      }
    }

    if (this.move.ruler <= this.fixedColumnIndex) {
      this.move.ruler = oldRuler
      return
    }

    this.move.cursor.downX = this.move.cursor.currentX
  }

  moveEnd(event: MouseEvent) {
    // 移動列左側ルーラー選択時は移動しない
    if (this.move.ruler === this.move.column.index) {
      this.moveReset()
      return
    }

    // 移動列右側ルーラー選択時は移動しない
    if (this.move.ruler === this.move.column.index + 1) {
      this.moveReset()
      return
    }

    const columnIndex = this.move.column.index

    // コピー元列の追加
    this.colsOrderList.splice(
      this.move.ruler,
      0,
      this.originalColumnIndex(columnIndex)
    )

    // コピー元列の削除
    if (this.move.ruler < columnIndex) {
      this.colsOrderList.splice(columnIndex + 1, 1)
    } else {
      this.colsOrderList.splice(columnIndex, 1)
    }

    this.colsPositionReset()

    each<ColInfo>(this.colsInfo, item => {
      item.moving = false
    })

    this.move.cursor.upX = event.pageX

    this.moveReset()
  }

  moveReset() {
    this.move.doing = false
    this.move.ruler = -1
  }

  originalColumnIndex(columnIndex: number) {
    return this.colsOrderList[columnIndex]
  }

  colsPositionReset() {
    let prevPos = 0
    each<number>(this.colsOrderList, originalIndex => {
      this.colsInfo[originalIndex].startX = prevPos
      prevPos += this.colsInfo[originalIndex].calcWidth
    })
  }

  @Emit('all-select')
  onAllSelect(): void {}

  @Emit('click:row')
  onClickRow(index: number) {
    return index
  }

  @Emit('dblclick:row')
  onDblclickRow(): void {}
}
